import React from 'react';
import {Route, IndexRoute} from 'react-router';
import Layout from './components/Layout';
import HomePage from './components/home/HomePage';
import AdminPage from './components/admin/AdminPage';
import ProtectedPage from './components/protected/ProtectedPage';
import ContractListPage from './components/list/List';
import ExportPage from './components/BI/ETL-categories-minutes';
import LoginPage from './components/login/LoginPage'; //eslint-disable-line import/no-named-as-default
import RegistrationPage from './components/registration/RegistrationPage'; //eslint-disable-line import/no-named-as-default
import {requireAdmin} from './actions/authActions';
import ConfigPage from './components/config/ConfigPage';
import TeachersPage from './components/home/TeachersPage';
import TeacherPage from './components/teacher/Teacher'


export default function Routes(store) {


  const checkAdmin = (nextState, replace, callback) => {
    store.dispatch(requireAdmin(nextState, replace, callback));
  };

  return ( <Route path="/" component={Layout}> <IndexRoute
component={TeachersPage}/> <Route path="Home" component={HomePage}/> <Route
path="layout" component={Layout}/> <Route path="contracts"
component={ContractListPage}/> <Route path="protected"
component={ProtectedPage}/> <Route path='teacher' component={TeacherPage}/>
<Route path="admin" component={AdminPage} onEnter={checkAdmin}/> <Route
path="login" component={LoginPage}/> <Route path='export'
component={ExportPage}/> <Route path='config' component={ConfigPage}/>
</Route> ); }



// WEBPACK FOOTER //
// ./src/routes.js